import { Component } from '@angular/core';
import BaseQuestion from '../base-question';
import { FeedbackQuestionService } from '../feedback-question.service';
import { FeedbackQuestion } from "../../../common/models/feedback-question";
import { FeedbackRemarkAnswerComponent } from "../../answers/remark";

@Component({
  selector: 'app-feedback-remark-question',
  templateUrl: 'feedback-remark-question.component.html',
  standalone: true,
  imports: [
    FeedbackRemarkAnswerComponent
  ],
  styleUrls: ['./../feedback-question.css']
})
export class FeedbackRemarkQuestionComponent extends BaseQuestion {
    public static type = FeedbackQuestion.TYPE_REMARK;

    constructor(feedbackQuestionService: FeedbackQuestionService) {
        super(feedbackQuestionService);
    }
}
